import React, { useEffect } from 'react'
import { graphql } from 'gatsby'

import type { DrupalTemplate, DrupalNode } from '../drupal'

import IndexLayout from '../layouts'
import Paragraphs, { Paragraph } from '../components/paragraphs'
import Stack from '../components/ui/Stack'

export { Head } from "../layouts/Head"

export interface NodePage extends DrupalNode {
	field_boolean: boolean
	relationships: {
		field_paragraphs: Paragraph[]
	}
}

const PageTemplate: DrupalTemplate<NodePage> = ({ data: { node } }) => {
	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search)

		if (urlParams.has('result') && urlParams.get('result') !== 'success') {
			switch (window.location.pathname) {
				case '/jaseneksi/kiitos':
					window.location.replace('/jaseneksi')
					break
			}
		}
	})

	return (
		<IndexLayout node={node}>
			<Stack css={{ marginBottom: 'var(--spacing)' }}>
				<Paragraphs paragraphs={node.relationships.field_paragraphs} />
			</Stack>
		</IndexLayout>
	)
}

export default PageTemplate

export const query = graphql`
	query PageTemplateQuery($drupal_id: String!) {
		node: nodePage(drupal_id: { eq: $drupal_id }) {
			transparentHeader: field_boolean
			drupal_internal__nid
			langcode
			title
			body {
				processed
				format
			}
			metatag_normalized {
				tag
				attributes {
					property
					content
					name
				}
			}
			relationships {
				field_paragraphs {
					...Paragraphs
				}
			}
		}
	}
`
